import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=06cf8818&scoped=true&"
import script from "./supervision.vue?vue&type=script&lang=js&"
export * from "./supervision.vue?vue&type=script&lang=js&"
import style0 from "./supervision.vue?vue&type=style&index=0&id=06cf8818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf8818",
  null
  
)

export default component.exports